// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'
import type { SocialProfile } from '@innolab-trader/tradovate-types'
import type { SocialSignInProvider } from '@innolab-trader/tradovate-types/src/enums/socialSignInProvider'

export interface GetSocialProfile {
  provider: SocialSignInProvider
  authCode: string
  appId?: string
  organization?: string
}

export interface SocialProfileResponse {
  errorText?: string
  socialProfile?: SocialProfile
  idToken?: string
}

/**
 * Validate GetSocialProfile request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateGetSocialProfile(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateGetSocialProfile(request: GetSocialProfile): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (req.provider === undefined || req.provider === null) {
    errors.push({
      field: 'provider',
      code: 'required',
      message: 'provider is required'
    })
  }

  if (req.authCode === undefined || req.authCode === null) {
    errors.push({
      field: 'authCode',
      code: 'required',
      message: 'authCode is required'
    })
  }
  if (typeof req.authCode === 'string' && req.authCode.length > 8192) {
    errors.push({
      field: 'authCode',
      code: 'too_long',
      message: 'authCode must not exceed 8192 characters',
      argument: '8192'
    })
  }
  if (typeof req.authCode === 'string' && req.authCode.trim() === '') {
    errors.push({
      field: 'authCode',
      code: 'required',
      message: 'authCode cannot be empty'
    })
  }

  if (typeof req.appId === 'string' && req.appId.length > 64) {
    errors.push({
      field: 'appId',
      code: 'too_long',
      message: 'appId must not exceed 64 characters',
      argument: '64'
    })
  }

  if (typeof req.organization === 'string' && req.organization.length > 64) {
    errors.push({
      field: 'organization',
      code: 'too_long',
      message: 'organization must not exceed 64 characters',
      argument: '64'
    })
  }

  return errors
}

export const getSocialProfile = postEndpoint<GetSocialProfile, SocialProfileResponse>('/auth/getSocialProfile')
